import { c as _c } from "react/compiler-runtime";
import { SelectProjectRole } from "@components/role/select-project-role";
import { MemberRoleReadOnly } from "@components/table/members/members-column/role-column/member-role-read-only";
import { RemoveFromProjectDialog } from "@components/project/remove-from-project-dialog";
import { useProjectMemberActions } from "@hooks/projects/use-project-member-actions";
import { useProjectRoleXgSeat } from "@hooks/projects/use-project-role-xg-seat";
import { useChangeMemberRole } from "@hooks/use-change-member-role";
import { DEFAULT_TEXT_FONT_SIZE } from "@styles/common-styles";
import { formatUserRoleType } from "@utils/data-display";
import { useState } from "react";
/** Render and adjust member roles in project context. */
export function ProjectMemberRole(t0) {
  const $ = _c(40);
  const {
    companyId,
    project,
    memberIdentityRole,
    isReadOnly: t1,
    location,
    member
  } = t0;
  const isReadOnly = t1 === undefined ? false : t1;
  const memberActions = useProjectMemberActions(project);
  const [isRemoveDialogOpen, setIsRemoveDialogOpen] = useState(false);
  let t2;
  if ($[0] !== companyId || $[1] !== location || $[2] !== memberIdentityRole.identity || $[3] !== memberIdentityRole.role || $[4] !== project) {
    t2 = {
      companyId,
      location,
      subjectType: "project",
      memberIdentity: memberIdentityRole.identity,
      currentRole: memberIdentityRole.role,
      selectedProject: project
    };
    $[0] = companyId;
    $[1] = location;
    $[2] = memberIdentityRole.identity;
    $[3] = memberIdentityRole.role;
    $[4] = project;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const {
    changeMemberRole
  } = useChangeMemberRole(t2);
  const {
    requestRoleChange,
    xgSeatDialog,
    disabledRoles
  } = useProjectRoleXgSeat({
    member,
    applyRoleChange
  });
  let t3;
  if ($[6] !== memberActions || $[7] !== memberIdentityRole) {
    t3 = memberActions.canChangeRole(memberIdentityRole);
    $[6] = memberActions;
    $[7] = memberIdentityRole;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const canEditRole = t3;
  let t4;
  if ($[9] !== member || $[10] !== memberActions || $[11] !== memberIdentityRole) {
    t4 = !!member && memberActions.canRemove(memberIdentityRole);
    $[9] = member;
    $[10] = memberActions;
    $[11] = memberIdentityRole;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  const canRemove = t4;
  if (isReadOnly) {
    let t5;
    if ($[13] !== memberIdentityRole.role) {
      t5 = <MemberRoleReadOnly role={memberIdentityRole.role} variant="borderless" />;
      $[13] = memberIdentityRole.role;
      $[14] = t5;
    } else {
      t5 = $[14];
    }
    return t5;
  }
  if (!canEditRole && !canRemove) {
    let t5;
    if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = {
        fontSize: DEFAULT_TEXT_FONT_SIZE
      };
      $[15] = t5;
    } else {
      t5 = $[15];
    }
    let t6;
    if ($[16] !== memberIdentityRole.role) {
      t6 = formatUserRoleType(memberIdentityRole.role);
      $[16] = memberIdentityRole.role;
      $[17] = t6;
    } else {
      t6 = $[17];
    }
    let t7;
    if ($[18] !== t6) {
      t7 = <span style={t5}>{t6}</span>;
      $[18] = t6;
      $[19] = t7;
    } else {
      t7 = $[19];
    }
    return t7;
  }
  async function applyRoleChange(role) {
    try {
      await changeMemberRole(role);
    } catch {}
  }
  const t5 = memberIdentityRole.role;
  let t6;
  if ($[20] !== requestRoleChange) {
    t6 = role_0 => void requestRoleChange(role_0);
    $[20] = requestRoleChange;
    $[21] = t6;
  } else {
    t6 = $[21];
  }
  let t7;
  if ($[22] !== canRemove) {
    t7 = canRemove ? () => setIsRemoveDialogOpen(true) : undefined;
    $[22] = canRemove;
    $[23] = t7;
  } else {
    t7 = $[23];
  }
  let t8;
  if ($[24] !== canEditRole || $[25] !== disabledRoles || $[26] !== t5 || $[27] !== t6 || $[28] !== t7) {
    t8 = <SelectProjectRole selectedRole={t5} onChange={t6} variant="borderless" disabledRoles={disabledRoles} isRoleEditable={canEditRole} onRemove={t7} />;
    $[24] = canEditRole;
    $[25] = disabledRoles;
    $[26] = t5;
    $[27] = t6;
    $[28] = t7;
    $[29] = t8;
  } else {
    t8 = $[29];
  }
  let t9;
  if ($[30] !== companyId || $[31] !== isRemoveDialogOpen || $[32] !== location || $[33] !== member || $[34] !== project) {
    t9 = member && isRemoveDialogOpen && <RemoveFromProjectDialog companyId={companyId} project={project} member={member} location={location} onClose={() => setIsRemoveDialogOpen(false)} />;
    $[30] = companyId;
    $[31] = isRemoveDialogOpen;
    $[32] = location;
    $[33] = member;
    $[34] = project;
    $[35] = t9;
  } else {
    t9 = $[35];
  }
  let t10;
  if ($[36] !== t8 || $[37] !== t9 || $[38] !== xgSeatDialog) {
    t10 = <>{t8}{t9}{xgSeatDialog}</>;
    $[36] = t8;
    $[37] = t9;
    $[38] = xgSeatDialog;
    $[39] = t10;
  } else {
    t10 = $[39];
  }
  return t10;
}